module.exports = __webpack_public_path__ + "static/media/illustration-element-08.cee8c4ab.svg";